import React from "react";
import styles from "./ProjectBox.module.scss";

const ProjectBox = ({
  code_name,
  mascot_image_url,
  name,
  documentation_link
}) => (
  <a className={styles.projectBox} href={documentation_link || "#"}>
    <div className={styles.projectBoxMascot}>
      <img src={mascot_image_url} alt="" />
    </div>
    <div className={styles.projectBoxContent}>
      <div className={styles.projectBoxContentTitle}>{code_name}</div>
      <div className={styles.projectBoxContentDescription}>{name}</div>
    </div>
    <div className={styles.projectBoxIcon}>
      <i className="fa-solid fa-chevron-right" />
    </div>
  </a>
);

export default ProjectBox;
